import _ from 'underscore';
import { useCallback } from 'react';

export function useGetIsPilotEnabled({ permissions }) {
  return useCallback(pilotName => _.get(permissions, ['dynamic', pilotName]), [permissions]);
}
